import styled from "styled-components";

export const CardWrapper = styled.div`
  margin-top: 4rem;

  a {
    color: #4285f4 !important;
    font-family: Catamaran;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 15px; /* 125% */
    text-decoration-line: underline !important;
    text-transform: lowercase;
    display: block;
    margin: 1rem 0 0 0;
  }

  .link-div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .card {
    border-radius: 10px;
    border-left: 8px solid #4285f4;
    background: #fff;
    box-shadow: 0px 1px 16px 0px rgba(0, 0, 0, 0.25);
    width: 228px;
    min-height: 112px;
    padding-bottom: 2rem;

    @media (max-width: 1399.98px) {
      /* width: 100%; */
    }
  }

  .card-img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 61px;
    height: 61px;
    margin-top: 1rem;
  }

  .card-title {
    text-align: center;
    color: #032b88;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
    margin-top: 10px;
  }

  .card-body {
    padding: 0rem 0rem;
  }

  .card-text {
    color: #4d4d4d;
    font-size: 14px;
    font-family: Catamaran !important;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-transform: capitalize;
    margin-top: 20px;
  }
`;
